import dynamic from "next/dynamic";
import { ReactNode } from "react";

// Dynamically import CSSTransition only on client side to avoid build issues
// Using 'as any' to avoid type checking during build
const CSSTransition = dynamic(
  () =>
    import("react-transition-group").then((mod) => mod.CSSTransition) as any,
  { ssr: false }
) as any;

// Define props without importing types from react-transition-group
type ClientCSSTransitionProps = {
  children: ReactNode;
  in?: boolean;
  nodeRef?: React.RefObject<HTMLElement>;
  classNames?: string;
  addEndListener?: (done: () => void) => void;
  timeout?: number | { appear?: number; enter?: number; exit?: number };
  appear?: boolean;
  enter?: boolean;
  exit?: boolean;
  unmountOnExit?: boolean;
  mountOnEnter?: boolean;
  [key: string]: any; // Allow any other props
};

const ClientCSSTransition = ({
  children,
  ...props
}: ClientCSSTransitionProps) => {
  // During SSR, render children without transition
  if (typeof window === "undefined") {
    return <>{children}</>;
  }

  return <CSSTransition {...props}>{children}</CSSTransition>;
};

export default ClientCSSTransition;
